/**
 * Utility functions for employee number and candidate record searching across the Probation module.
 */

export const matchEmpNo = (candidateEmpNo: any, searchQuery: string): boolean => {
  if (!searchQuery || candidateEmpNo === undefined || candidateEmpNo === null) return false;

  const rawEmp = String(candidateEmpNo).trim().toLowerCase();
  const q = searchQuery.trim().toLowerCase();
  if (!rawEmp || !q) return false;

  // 1. Direct raw string substring match (preserves leading zeroes like "00004411")
  if (rawEmp.includes(q)) return true;

  // 2. Normalized numeric match (strips leading zeroes, e.g. "4411" matches "00004411")
  const normEmp = rawEmp.replace(/^0+/, "");
  const normQ = q.replace(/^0+/, "");

  if (normEmp && normQ && normEmp.includes(normQ)) return true;

  return false;
};

export const matchCandidateRecord = (c: any, searchQuery: string): boolean => {
  if (!searchQuery || !searchQuery.trim()) return true;
  const q = searchQuery.trim().toLowerCase();

  if (!c || typeof c !== "object") return false;

  // Check Emp No using matchEmpNo helper across all possible employee number properties
  const empNoCandidates = [
    c.empNo, c.emp_no, c.empId, c.emp_id, c.id, c.employeeNo, c.employee_no, c.emp_number, c.empNumber, c.srNo
  ];
  for (const empVal of empNoCandidates) {
    if (empVal !== undefined && empVal !== null && matchEmpNo(empVal, q)) {
      return true;
    }
  }

  // Check Name
  const nameVal = (c.name || c.empName || c.emp_name || c.employeeName || "").toString().toLowerCase();
  if (nameVal && nameVal.includes(q)) return true;

  // Check Designation
  const desigVal = (c.designation || c.designationId || c.designation_name || "").toString().toLowerCase();
  if (desigVal && desigVal.includes(q)) return true;

  // Check Department
  const deptVal = (c.department || c.dept || c.department_name || "").toString().toLowerCase();
  if (deptVal && deptVal.includes(q)) return true;

  // Check Office Order / Remarks / PVR / DAR / Vigilance if query matches
  const extraVal = (c.officeOrderNo || c.orderNumber || c.order_no || c.remarks || c.committeeRemarks || c.approvalRemarks || c.pvr || c.vigilance || "").toString().toLowerCase();
  if (extraVal && extraVal.includes(q)) return true;

  return false;
};
